import HttpCotinService from './HttpCotinService';

export interface Preferencia {
    [preferencia: string]: unknown;
}

export const PREFERENCIA_LIBRAS = 'libras';
export const PREFERENCIA_TUTORIAL = 'tutorial';
export const PREFERENCIA_LOGGING = 'logging';
export const PREFERENCIA_AUDITORIA = 'auditoria';
export const PREFERENCIA_ATALHOS_FAVORITOS = 'atalhosFavoritosArvoreMenu';
export const PREFERENCIA_BRASAO_OFICIAL = 'brasaoOficial';

const PREFERENCIAS_API_URI = 'BFFProxy/configuracoesdeusuarios';

type PreferenciasListener = (preferencias: Preferencia) => void;

const preferenciasListeners = new Set<PreferenciasListener>();
let currentPreferencias: Preferencia = ensureDefaults({});
const inflightSyncRequests = new Map<string, Promise<void>>();

function ensureDefaults(preferencias: Preferencia): Preferencia {
    return {
        ...preferencias,
        [PREFERENCIA_TUTORIAL]: preferencias[PREFERENCIA_TUTORIAL] === false ? false : true,
        [PREFERENCIA_AUDITORIA]: preferencias[PREFERENCIA_AUDITORIA] === false ? false : true,
        [PREFERENCIA_LIBRAS]: preferencias[PREFERENCIA_LIBRAS] === false ? false : true,
    };
}

function normalizePreferencias(raw: Record<string, unknown> | null | undefined): Preferencia {
    if (!raw || typeof raw !== 'object') {
        return {};
    }
    return { ...raw };
}

function emitPreferencias(preferencias: Preferencia): void {
    currentPreferencias = ensureDefaults(preferencias);
    preferenciasListeners.forEach((listener) => listener(currentPreferencias));
}

export function subscribePreferencias(listener: PreferenciasListener): () => void {
    listener(currentPreferencias);
    preferenciasListeners.add(listener);
    return () => preferenciasListeners.delete(listener);
}

export function getPreferenciasSnapshot(): Preferencia {
    return currentPreferencias;
}

export async function syncPreferenciasFromApi(loginAD?: string | null): Promise<void> {
    const login = (loginAD ?? '').trim();
    const key = login || '__empty__';
    const inflight = inflightSyncRequests.get(key);
    if (inflight) {
        return inflight;
    }

    const request = (async () => {
        if (!login) {
            emitPreferencias({});
            return;
        }

        try {
            const preferenciasApi = await HttpCotinService.Get<Record<string, unknown>>(
                `${PREFERENCIAS_API_URI}?loginAD=${encodeURIComponent(login)}`
            );
            emitPreferencias(ensureDefaults(normalizePreferencias(preferenciasApi)));
        } catch (error) {
            console.warn('Nao foi possivel carregar preferencias pela API.', error);
            emitPreferencias({});
        }
    })().finally(() => {
        if (inflightSyncRequests.get(key) === request) {
            inflightSyncRequests.delete(key);
        }
    });

    inflightSyncRequests.set(key, request);
    return request;
}

export async function setPreferencia(
    loginAD: string,
    preferenciaNome: string,
    preferenciaValor: unknown
): Promise<void> {
    const anterior = { ...currentPreferencias };
    const preferencia = { ...anterior, [preferenciaNome]: preferenciaValor };
    emitPreferencias(preferencia);

    const login = loginAD.trim();
    if (!login) {
        return;
    }

    try {
        await HttpCotinService.Put<void>(
            `${PREFERENCIAS_API_URI}/${preferenciaNome}?loginAD=${encodeURIComponent(login)}`,
            preferenciaValor
        );
    } catch (error) {
        emitPreferencias(anterior);
        console.warn(`Nao foi possivel salvar preferencia '${preferenciaNome}' na API.`, error);
        throw error;
    }
}
